module.exports = __webpack_public_path__ + "static/media/S (141).6151110d.jpg";